import React from "react";
import { keyframes } from "@emotion/core";
import { RiLoader4Line } from "react-icons/ri";

export default ({ size, color }) => (
    <RiLoader4Line
        size={ size || 64 }
        color={ color || "var(--green)" }
        css={{
            animation: `${keyframes({
                from: {
                    transform: "rotate(0deg)",
                },
                to: {
                    transform: "rotate(360deg)",
                },
            })} .8s linear infinite`,
        }}
    />
);
